export default "__VITE_ASSET__vpJtCn4S__"